import React from "react"

export default function Footer() {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "10px",
      }}
    >
      <a
        href="https://advertpark.com/"
        target="_blank"
        rel="noopener noreferrer"
        style={{color: "#000", textDecoration: "none"}}
      >
        Powered By Advertpark
      </a>
    </div>
  )
}
